export enum DataHooks {
  WRAPPER = 'empty-state-wrapper',
  CONTENT = 'empty-state-content',
}
